import React from 'react';
import Chart from '@framework/ui/Organisms/Analytics/Chart';
import { ChartTypes } from '@framework/ui/Organisms/Analytics/Chart/constants';
import getChartConfig from './config';
import { ISettingsChart } from '@/creditflowresearch/domain/vo/Chart/ISettingsChart';

interface IProps {
  settings?: Partial<ISettingsChart>,
}

const EmptyChart = ({ settings }: IProps) => {
  return (
    <Chart
      type={ ChartTypes.Highstock }
      data={ [{ x: 0, y: 0 }] }
      configOptions={ { settings } }
      getConfig={ getChartConfig }
    />
  );
};

export default EmptyChart;
